import { Box, Stack, Typography } from "@mui/material";

export const ProjectSectionHeader = ({ icon, title }: { icon: React.ReactNode; title: React.ReactNode }) => (
    <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={(t) => ({
            mb: 1,
            bgcolor: "grey.100",
            p: 1,
            borderRadius: 1,
            border: `1px solid ${t.palette.divider}`,
        })}
    >
        <Stack direction="row" alignItems="center" spacing={1} >
            <Box sx={{ display: "inline-flex", alignItems: "center" }}>{icon}</Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{title}</Typography>
        </Stack>
    </Stack>
);